import axios from '../../utils/axios'
import { getUser } from 'src/utils/Common';

export const getWarehouseProduct = ({startDate, endDate}) => {
  const SessionUser = getUser();
  return axios.get(`/GetArtemisWarehouseProducts/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${startDate}/${endDate}`)
};
